import { useCallback } from "react";
import styled, { keyframes } from "styled-components";
import { BsChevronDoubleUp } from "react-icons/bs";
import { animateScroll } from "react-scroll";
import { constants } from "constants";
import { useWindowScroll } from "hooks/useWindowScroll";

const appearanceAnimation = keyframes`
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const disappearanceAnimation = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
`;

const StyledTopScroller = styled.div`
  position: fixed;
  z-index: 12;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  right: max(24px, env(safe-area-inset-right, 0px));
  width: 54px;
  height: 54px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 700px) {
    bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  }

  @media (max-width: 479px) {
    right: max(14px, env(safe-area-inset-right, 0px));
  }
`;

const StyledScroller = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 54px;
  color: ${constants.colors.white};
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  transition:
    opacity 220ms ease,
    transform 220ms ease;

  &.visible {
    animation: ${appearanceAnimation} 1s forwards;
  }

  &.hidden {
    animation: ${disappearanceAnimation} 1s forwards;
  }
`;

const StyledScrollerIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  font-size: 27px;
  z-index: 1;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  background-color: rgba(232, 155, 48, 0.7);
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.25),
    0 0 24px rgba(232, 155, 48, 0.14);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition:
    background-color 180ms ease,
    transform 180ms ease;

  &:hover {
    background-color: rgba(232, 155, 48, 0.86);
    transform: translateY(-2px);
  }
`;

export const TopScroller = () => {
  const { y } = useWindowScroll();

  const scrollToTop = useCallback(() => {
    animateScroll.scrollTo(-1, { smooth: true, duration: 0, delay: 0 });
  }, []);

  return (
    <StyledTopScroller>
      <StyledScroller
        className={y < window.innerHeight / 2 ? "hidden" : "visible"}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <StyledScrollerIcon>
          <BsChevronDoubleUp />
        </StyledScrollerIcon>
      </StyledScroller>
    </StyledTopScroller>
  );
};
